import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { MailWorkflowListComponent }     from './mail-workflow-list.component';
import { MailWorkflowDetailComponent }   from './mail-workflow-detail.component';
import { MailWorkflowPageComponent }     from './mail-workflow-page.component';
import { MailInitiateComponent }         from './mail-initiate.component';
import { MailMemoTemplateComponent }     from './mail-memo-template.component';
import { MailWorkflowService }           from './mail-workflow.service';
import { SpSharedModule }               from '../shared/sp-shared.module';
import { SpDirectoryPickerComponent }   from '../shared/directory/sp-directory-picker.component';

const routes: Routes = [
  // Full-screen: task detail (existing)
  { path: 'task/:taskId',        component: MailWorkflowDetailComponent },

  // Full-screen: open a saved draft for editing / dispatching
  { path: 'draft/:draftId',      component: MailInitiateComponent },

  // Full-screen: new mail wizard (Screen 6)
  { path: 'new',                 component: MailInitiateComponent },

  // Full-screen: internal memo template picker (Screen 7)
  { path: 'memo/template',       component: MailMemoTemplateComponent },

  // Full-screen: OO editor wrapper for a saved memo draft (Screen 8)
  // NOTE: This route hands off to the existing OnlyOffice component in your app.
  // The MailWorkflowDetailComponent handles the OO editing view when status=DRAFT
  // and mailType=INTERNAL_MEMO by embedding the OO iframe.
  { path: 'memo/edit/:draftId',  component: MailWorkflowDetailComponent },
];

@NgModule({
  declarations: [
    MailWorkflowListComponent,
    MailWorkflowDetailComponent,
    MailWorkflowPageComponent,
    MailInitiateComponent,
    MailMemoTemplateComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forChild(routes),
    SpSharedModule,
    SpDirectoryPickerComponent
  ],
  exports: [
    MailWorkflowListComponent,
    MailWorkflowDetailComponent,
    MailWorkflowPageComponent,
  ],
  providers: [MailWorkflowService]
})
export class MailWorkflowModule {}